import React from 'react';
import './index.css';

const Footer = () => {
    return (
        <footer>
            <div className="one"></div>
            <div className="two"></div>
            <div className="three"></div>
            <div className="four"></div>
            <div className="five"></div>
            <div className="six"></div>
            <div className="seven"></div>
            <div className="eight"></div>
        </footer>
    );
}

export default Footer;
